<template>
  <div>
    <hr style="color:black; height:1px;" />
    <b-row>
      <b-col>
        <h3><b><i class="fas fa-user-lock mr-2"></i>{{$t(translateKey)}}</b></h3>
      </b-col>
      <b-col cols="6" class="ml-auto">
        <slot name="rightTopSection"></slot>
      </b-col>
    </b-row>
    <slot name="additionalAgentSection"></slot>
    <AssignAgent v-model="value" :allDisabled="allDisabledValue" :displayOnly="displayOnly" :disabledName="disabledName" :haveAction="haveAction"></AssignAgent>
    <slot name="afterSection"></slot>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITvSelect, FITTextInput, FITDatePicker, FITSelect, FITTextarea, FITAutoSearch, FITWorkflowFileUpload } from '@/components'
import AssignAgent from './AssignAgent'

export default {
  name: 'PolicyAgent',
  components: {
    AssignAgent,
    FITFormCard,
    FITvSelect,
    FITTextInput,
    FITDatePicker,
    FITSelect,
    FITTextarea,
    FITAutoSearch,
    FITWorkflowFileUpload
  },
  props: {
    haveAction: {
      type: Boolean,
      default: false
    },
    disabledName: {
      type: Boolean,
      default: false
    },
    displayOnly: {
      type: Boolean,
      default: false
    },
    translateKey: {
      type: String,
      default: ''
    },
    value: [Array],
    allDisabled: {
      type: Boolean,
      default: false,
    },
    disableOldItem: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    value(newData, oldData) {
      // console.debug(newData);
      this.$emit('input', newData);
    }
  },
  computed:{
  allDisabledValue(){
    let allDisabled = this.allDisabled;
    let permissionLevel = this.$store.state.permissionLevel;
    if (permissionLevel> 3.5){
       allDisabled = true
    }
    return allDisabled;
   }



  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/components/PolicyAgent.vue